export default __webpack_public_path__ + "static/media/0058.09504613.jpg";